export const UPLOAD_MAX_NUMBER_FIELDS = 5;
